// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3khkc","left":"InfoRow_left__2zQr1"};